import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useRecoilCallback } from 'recoil'

import { Select } from 'mailup-web-components'

import { searchState } from '../../recoil/state/search'

export const InputFilterByField = ({ onChange }) => {
  const intl = useIntl()
  const { filterByField } = useRecoilValue(searchState)

  const { current: options } = useRef([
    {
      label: intl.formatMessage({ id: 'Load.EmailMessageList.LastUpdateHeaderColumn' }),
      value: 'LastUpdated'
    }, {
      label: intl.formatMessage({ id: 'Load.EmailMessageList.LastSentHeaderColumn' }),
      value: 'LastSent'
    }
  ])

  const handleChange = useRecoilCallback(({ set }) => value => {
    set(searchState, (prev) => {
      onChange(value)
      return {
        ...prev,
        filterByField: value
      }
    })
  })

  return (
    <Select
      searchable={false}
      options={options}
      onChange={handleChange}
      value={filterByField}
    />
  )
}
